<div class="breadcrumb-header justify-content-between">
  <div class="my-auto">
    <div class="d-flex">
      <h4 class="content-title mb-0 my-auto">Crear Factura Convenio</h4>
      <span class="text-muted mt-1 tx-13 ms-2 mb-0">/ Ordenes Convenio</span>
    </div>
  </div>
  <div class="d-flex my-xl-auto right-content mr-2">
    <button class="btn btn-light me-2" type="button" (click)="volver()" [disabled]="cargando">Volver</button>
    <button class="btn btn-primary" type="button" (click)="guardarFactura()" [disabled]="cargando || !detalleFactura.length">
      <i class="fa fa-save me-1"></i> Guardar
    </button>
  </div>
</div>

@if (cargando) {
  <div class="alert alert-info">{{ mensajeCarga }}</div>
}

@if (error) {
  <div class="alert alert-danger">{{ error }}</div>
}

<div class="row row-sm">
  <div class="col-md-6">
    <div class="card">
      <div class="card-header convenio-card-header">
        <h6 class="card-title mb-0 text-white">Datos del Cliente</h6>
      </div>
      <div class="card-body">
        <div class="d-flex gap-2 mb-3">
          <ng-select class="form-control"
            placeholder="Ingrese cédula, nombre, apellido..."
            (keydown)="buscarPaciente($event)"
            (keyup)="buscarPaciente($event)"
            [(ngModel)]="selectedCliente"
            (change)="obtenerClienteSeleccionado(selectedCliente)">
            @for (obj of pacienteslist; track obj) {
              <ng-option [value]="obj.codigo">{{ obj.datos }}</ng-option>
            }
          </ng-select>
          <button type="button" class="btn btn-outline-primary" (click)="modalAgregarPaciente(mdlAgregarPaciente)">
            Agregar
          </button>
        </div>
        <p><strong>Nombre:</strong> {{ cliente.nombre }}</p>
        <p><strong>Cédula o Ruc:</strong> {{ cliente.cedula }}</p>
        <p><strong>Teléfono:</strong> {{ cliente.telefono }}</p>
        <p><strong>Dirección:</strong> {{ cliente.direccion }}</p>
        <p><strong>Fec. Nac.:</strong> {{ cliente.fechaNacimiento }}</p>
        <p><strong>Correo Electrónico:</strong> {{ cliente.email }}</p>
      </div>
    </div>
  </div>
  <div class="col-md-6">
    <div class="card">
      <div class="card-header convenio-card-header">
        <h6 class="card-title mb-0 text-white">Datos de la factura</h6>
      </div>
      <div class="card-body">
        <p><strong>Facturador:</strong> {{ usuario.nombre }}</p>
        <p><strong>Doctor:</strong> {{ doctor.nombre }}</p>
        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label">Forma de Pago</label>
            <select class="form-control" [(ngModel)]="metodoPago">
              <option value="EFECTIVO">EFECTIVO</option>
              <option value="TARJETA DE DEBITO">TARJETA DEBITO</option>
              <option value="TARJETA DE CREDITO">TARJETA CREDITO</option>
              <option value="TRANSFERENCIA">TRANSFERENCIA</option>
            </select>
          </div>
          <div class="col-md-6">
            <label class="form-label">Detalle</label>
            <div class="d-flex gap-3 pt-2">
              <label><input type="radio" name="tipoDetalle" [checked]="tipoDetalle === 'detallado'" (change)="cambiarTipoDetalle('detallado')"> Detallado</label>
              <label><input type="radio" name="tipoDetalle" [checked]="tipoDetalle === 'agrupado'" (change)="cambiarTipoDetalle('agrupado')"> Agrupado</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #mdlAgregarPaciente let-modal>
  <div class="modal-header">
    <h6 class="modal-title">Ingresar Nuevo Cliente</h6>
    <button type="button" class="close" aria-label="Close" (click)="cerrarModalCliente()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="mb-3">
      <b>¿Tiene número de identificación?</b>
      <div class="d-flex gap-3 mt-1">
        <label><input type="checkbox" [(ngModel)]="checkIdentificacionSI" (change)="cambiarSIIdent()"> Sí</label>
        <label><input type="checkbox" [(ngModel)]="checkIdentificacionNO" (change)="cambiarNOIdent()"> No</label>
      </div>
    </div>

    @if (spinnerBooleanBuscarData) {
      <div class="text-center py-2">
        <div class="spinner-grow" role="status"><span class="sr-only">Loading...</span></div>
        <p class="mb-0 mt-1">Cargando, por favor espere...</p>
      </div>
    }

    @if (checkIdentificacionNO) {
      <div class="mb-3">
        <b>Identificación</b>
        <input type="text" class="form-control" [(ngModel)]="randomCedula" readonly>
      </div>
    }

    @if (checkIdentificacionSI) {
      <div class="row">
        <div class="col-md-5 mb-3">
          <b>Tipo ID</b>
          <ng-select class="form-control" [(ngModel)]="nuevaIdentificacionPaciente">
            <ng-option value="05">CÉDULA</ng-option>
            <ng-option value="04">RUC</ng-option>
            <ng-option value="06">PASAPORTE</ng-option>
            <ng-option value="08">EXTERIOR</ng-option>
          </ng-select>
        </div>
        <div class="col-md-7 mb-3">
          <b>Identificación</b>
          <div class="input-group">
            <input type="text" class="form-control" placeholder="Número" [(ngModel)]="identificacionPaciente">
            <button class="btn btn-light" type="button" (click)="buscarDataPersonas()">
              <i class="mdi mdi-account-search"></i>
            </button>
          </div>
        </div>
      </div>
    }

    <div class="mb-3">
      <b>Nombre</b>
      <input type="text" class="form-control" placeholder="Nombre completo" [(ngModel)]="nombrePaciente">
    </div>

    <div class="row">
      <div class="col-md-6 mb-3">
        <b>Fecha Nac.</b>
        <input type="date" class="form-control" (change)="cambiarFechaNacimiento()" [(ngModel)]="fechaNacimientoPaciente">
      </div>
      <div class="col-md-6 mb-3">
        <b>Edad</b>
        <input type="number" class="form-control" [(ngModel)]="nuevaEdadPaciente" readonly>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 mb-3">
        <b>Sexo</b>
        <ng-select class="form-control" [(ngModel)]="sexoPaciente">
          <ng-option value="">Seleccione...</ng-option>
          <ng-option value="masculino">MASCULINO</ng-option>
          <ng-option value="femenino">FEMENINO</ng-option>
          <ng-option value="persona-juridica">PERSONA JURÍDICA</ng-option>
          <ng-option value="otro">OTROS</ng-option>
        </ng-select>
      </div>
      <div class="col-md-6 mb-3">
        <b>Teléfono</b>
        <input type="text" class="form-control" placeholder="Teléfono" [(ngModel)]="nuevoTelefonoCliente">
      </div>
    </div>

    <div class="mb-3">
      <b>Dirección</b>
      <input type="text" class="form-control" placeholder="Dirección" [(ngModel)]="direccionPaciente">
    </div>

    <div class="mb-3">
      <b>Email</b>
      <input type="email" class="form-control" placeholder="correo@ejemplo.com" [(ngModel)]="nuevoEmailPaciente">
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="cerrarModalCliente()">Cerrar</button>
    <button type="button" class="btn btn-primary" (click)="guardarPaciente()" [disabled]="guardarCliente">
      Guardar
    </button>
  </div>
</ng-template>

<div class="row row-sm">
  <div class="col-12">
    <div class="card">
      <div class="card-header convenio-card-header">
        <h6 class="card-title mb-0 text-white">Detalle de la factura</h6>
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>#</th>
                <th>Código</th>
                <th>Producto</th>
                <th>Detalle</th>
                <th>Cantidad</th>
                <th>Precio</th>
                <th>Total Neto</th>
              </tr>
            </thead>
            <tbody>
              @for (item of detalleFactura; track $index; let i = $index) {
                <tr>
                  <td>{{ i + 1 }}</td>
                  <td>{{ item.codigo }}</td>
                  <td>{{ item.nombre }}</td>
                  <td>{{ item.observacion }}</td>
                  <td>{{ item.cantidad }}</td>
                  <td>$ {{ item.precioSinIva | number: '1.2-2' }}</td>
                  <td>$ {{ item.tota | number: '1.2-2' }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>

        <div class="row justify-content-end">
          <div class="col-md-5">
            <table class="table">
              <tr><th>Subtotal IVA</th><td>$ {{ subtotalImpuesto }}</td></tr>
              <tr><th>Subtotal 0</th><td>$ {{ subtotalSinImpuesto }}</td></tr>
              <tr><th>Subtotal</th><td>$ {{ subtotal }}</td></tr>
              <tr><th>IVA 12%</th><td>$ {{ iva }}</td></tr>
              <tr><th>Total Pagar</th><td class="total">$ {{ total }}</td></tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
